import { Component } from 'react';
import { ReactComponent as Close } from 'assets/images/svg/Popclose.svg';
export default class Popup extends Component{
    render(){
        return(
            <>
                <div className='profile-container delete-image'>
                <div className='profile-popup-visible'>
                  <div className='popup-controls'>
                    <i className='popup_close' onClick={ this.props.handleCancel }><Close/></i>
                    <div className='popup-body'>
                      <div style={ this.props.textStyle ?? {} } dangerouslySetInnerHTML={ { __html: this.props.popupText } }></div>
                      <div className='buttons'>
                        <a class="btn btn_outline" onClick={ this.props.handleCancel }>{this.props.cancelText || 'Cancel'}</a>
                        <a class="btn btn_primary" onClick={ this.props.handleYes }>{this.props.yesText || 'Yes'}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
        )
    }
}